export default function OnelineText({ text = '' }) {
    return (text || '')
        .replace(/\\n|\\r/g, ' ')
        .replace(/[\r\n]+/g, ' ')
        .replace(/(?<!\s)-\s+|\s+-(?!\s)/g, '-') // Убираем пробелы вокруг дефиса (но не внутри слов)
        .replace(/\s+/g, ' ') // Схлопываем все множественные пробелы в один
        .trim();
}
